import { lazyWithRetry } from '../utils/common/lazyWithRetry';

export const MainPage = lazyWithRetry(
    () => import('../components/main_page/main/MainCommon'),
);
export const PrivacyPolicy = lazyWithRetry(
    () =>
        import('../components/main_page/sections/privacy_policy/PrivacyPolicy'),
);
export const TermsConditions = lazyWithRetry(
    () =>
        import(
            '../components/main_page/sections/privacy_policy/TermsConditions'
        ),
);
export const AboutPage = lazyWithRetry(
    () => import('../components/main_page/sections/about/AboutPage'),
);
export const ContactsPage = lazyWithRetry(
    () => import('../components/main_page/sections/about/ContactsPage'),
);
export const PartnerPage = lazyWithRetry(
    () => import('../components/main_page/sections/partners/PartnerPage'),
);
export const UnsubscribePage = lazyWithRetry(
    () => import('../components/main_page/sections/partners/UnsubscribePage'),
);
export const NudgeActionPage = lazyWithRetry(
    () => import('../components/auth/nudge/NudgeActionPage'),
);
export const NudgeUnsubscribePage = lazyWithRetry(
    () => import('../components/auth/nudge/NudgeUnsubscribePage'),
);
export const SavedSearchUnsubscribePage = lazyWithRetry(
    () => import('../components/auth/nudge/SavedSearchUnsubscribePage'),
);
export const Calculator = lazyWithRetry(
    () => import('../components/main_page/tools/Calculator'),
);
export const CountryCalculator = lazyWithRetry(
    () => import('../components/main_page/tools/CountryCalculator'),
);
export const ReRegistration = lazyWithRetry(
    () => import('../components/main_page/tools/ReRegistration'),
);
export const AveragePricePage = lazyWithRetry(
    () => import('../components/main_page/tools/AveragePricePage'),
);
export const Valuator = lazyWithRetry(
    () => import('../components/main_page/tools/Valuator'),
);
export const ModelGuidePage = lazyWithRetry(
    () => import('../components/main_page/tools/ModelGuidePage'),
);
export const MarketPage = lazyWithRetry(
    () => import('../components/main_page/tools/MarketPage'),
);
export const PaymentSuccess = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/PaymentSuccess'),
);
export const PaymentFail = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/PaymentFail'),
);
export const PaymentHistory = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/PaymentHistory'),
);
export const SellCarForm = lazyWithRetry(
    () => import('../components/sell/forms/SellCarForm'),
);
export const SellBikeForm = lazyWithRetry(
    () => import('../components/sell/forms/SellBikeForm'),
);
export const SellCommercialForm = lazyWithRetry(
    () => import('../components/sell/forms/SellCommercialForm'),
);
export const SellCarProForm = lazyWithRetry(
    () => import('../components/sell/forms/SellCarProForm'),
);
export const SellBikeProForm = lazyWithRetry(
    () => import('../components/sell/forms/SellBikeProForm'),
);
export const SellCommercialProForm = lazyWithRetry(
    () => import('../components/sell/forms/SellCommercialProForm'),
);
export const SellCar = lazyWithRetry(
    () => import('../components/sell/adverts/car/SellCar'),
);
export const SellBike = lazyWithRetry(
    () => import('../components/sell/adverts/bike/SellBike'),
);
export const SellCommercial = lazyWithRetry(
    () => import('../components/sell/adverts/commercial/SellCommercial'),
);
export const SellCarAllDetails = lazyWithRetry(
    () => import('../components/sell/adverts/all/SellCarAllDetails'),
);
export const SellBikeAllDetails = lazyWithRetry(
    () => import('../components/sell/adverts/all/SellBikeAllDetails'),
);
export const SellCommercialAllDetails = lazyWithRetry(
    () => import('../components/sell/adverts/all/SellCommercialAllDetails'),
);
export const SearchCabinetCar = lazyWithRetry(
    () => import('../components/sell/search/car/SearchCabinetCar'),
);
export const SearchCabinetBike = lazyWithRetry(
    () => import('../components/sell/search/bike/SearchCabinetBike'),
);
export const SearchCabinetCommercial = lazyWithRetry(
    () =>
        import('../components/sell/search/commercial/SearchCabinetCommercial'),
);
export const SearchCar = lazyWithRetry(
    () => import('../components/sell/search/car/SearchCar'),
);
export const SearchBike = lazyWithRetry(
    () => import('../components/sell/search/bike/SearchBike'),
);
export const SearchCommercial = lazyWithRetry(
    () => import('../components/sell/search/commercial/SearchCommercial'),
);
export const SearchFullCar = lazyWithRetry(
    () => import('../components/sell/search/car/SearchFullCar'),
);
export const SearchFullBike = lazyWithRetry(
    () => import('../components/sell/search/bike/SearchFullBike'),
);
export const SearchFullCommercial = lazyWithRetry(
    () => import('../components/sell/search/commercial/SearchFullCommercial'),
);
export const SellCarList = lazyWithRetry(
    () => import('../components/lists/sell/SellCarList'),
);
export const SellBikeList = lazyWithRetry(
    () => import('../components/lists/sell/SellBikeList'),
);
export const SellCommercialList = lazyWithRetry(
    () => import('../components/lists/sell/SellCommercialList'),
);
export const RentCarForm = lazyWithRetry(
    () => import('../components/rent/forms/RentCarForm'),
);
export const RentBikeForm = lazyWithRetry(
    () => import('../components/rent/forms/RentBikeForm'),
);
export const RentCommercialForm = lazyWithRetry(
    () => import('../components/rent/forms/RentCommercialForm'),
);
export const RentVehicle = lazyWithRetry(
    () => import('../components/rent/adverts/RentVehicle'),
);
export const RentAllDetails = lazyWithRetry(
    () => import('../components/rent/adverts/all/RentAllDetails'),
);
export const SearchRentCar = lazyWithRetry(
    () => import('../components/rent/search/car/SearchRentCar'),
);
export const SearchRentBike = lazyWithRetry(
    () => import('../components/rent/search/bike/SearchRentBike'),
);
export const SearchRentCommercial = lazyWithRetry(
    () => import('../components/rent/search/commercial/SearchRentCommercial'),
);
export const SearchCabinetRentCar = lazyWithRetry(
    () => import('../components/rent/search/car/SearchCabinetRentCar'),
);
export const SearchCabinetRentBike = lazyWithRetry(
    () => import('../components/rent/search/bike/SearchCabinetRentBike'),
);
export const SearchCabinetRentCommercial = lazyWithRetry(
    () =>
        import(
            '../components/rent/search/commercial/SearchCabinetRentCommercial'
        ),
);
export const SearchFullRentCar = lazyWithRetry(
    () => import('../components/rent/search/car/SearchFullRentCar'),
);
export const SearchFullRentBike = lazyWithRetry(
    () => import('../components/rent/search/bike/SearchFullRentBike'),
);
export const SearchFullRentCommercial = lazyWithRetry(
    () =>
        import('../components/rent/search/commercial/SearchFullRentCommercial'),
);
export const RentCarList = lazyWithRetry(
    () => import('../components/lists/rent/RentCarList'),
);
export const RentBikeList = lazyWithRetry(
    () => import('../components/lists/rent/RentBikeList'),
);
export const RentCommercialList = lazyWithRetry(
    () => import('../components/lists/rent/RentCommercialList'),
);
export const DealerForm = lazyWithRetry(
    () => import('../components/company/forms/DealerForm'),
);
export const AutoCompanyForm = lazyWithRetry(
    () => import('../components/company/forms/AutoCompanyForm'),
);
export const RentCompanyForm = lazyWithRetry(
    () => import('../components/company/forms/RentCompanyForm'),
);
export const PartsCompanyForm = lazyWithRetry(
    () => import('../components/company/forms/PartsCompanyForm'),
);
export const ServiceCompanyAddForm = lazyWithRetry(
    () => import('../components/company/forms/ServiceCompanyAddForm'),
);
export const ExpertCompanyForm = lazyWithRetry(
    () => import('../components/company/forms/ExpertCompanyForm'),
);
export const InsuranceCompanyForm = lazyWithRetry(
    () => import('../components/company/forms/InsuranceCompanyForm'),
);
export const DealerAdvert = lazyWithRetry(
    () => import('../components/company/advert/DealerAdvert'),
);
export const AutoCompanyAdvert = lazyWithRetry(
    () => import('../components/company/advert/AutoCompanyAdvert'),
);
export const RentAdvert = lazyWithRetry(
    () => import('../components/company/advert/RentAdvert'),
);
export const PartsCompanyAdvert = lazyWithRetry(
    () => import('../components/company/advert/PartsCompanyAdvert'),
);
export const ServiceCompanyAdvert = lazyWithRetry(
    () => import('../components/company/advert/ServiceCompanyAdvert'),
);
export const ExpertCompanyAdvert = lazyWithRetry(
    () => import('../components/company/advert/ExpertCompanyAdvert'),
);
export const InsuranceCompanyAdvert = lazyWithRetry(
    () => import('../components/company/advert/InsuranceCompanyAdvert'),
);
export const CompanyAllDetails = lazyWithRetry(
    () => import('../components/company/advert/all/CompanyAllDetails'),
);
export const CompanyAllList = lazyWithRetry(
    () => import('../components/lists/company/all/CompanyAllList'),
);
export const SearchCompany = lazyWithRetry(
    () => import('../components/company/search/SearchCompany'),
);
export const SearchCompanyFull = lazyWithRetry(
    () => import('../components/company/search/SearchCompanyFull'),
);
export const HtmlSitemap = lazyWithRetry(
    () => import('../components/seo/HtmlSitemap'),
);
export const AccountCabinet = lazyWithRetry(
    () => import('../components/auth/account/AccountCabinet'),
);
export const AdminImportPage = lazyWithRetry(
    () => import('../components/admin/import/AdminImportPage'),
);
export const Companies = lazyWithRetry(
    () => import('../components/auth/cabinet/Companies'),
);
export const FavoritesBike = lazyWithRetry(
    () => import('../components/auth/cabinet/favorites/FavoritesBike'),
);
export const FavoritesCar = lazyWithRetry(
    () => import('../components/auth/cabinet/favorites/FavoritesCar'),
);
export const FavoritesCommercial = lazyWithRetry(
    () => import('../components/auth/cabinet/favorites/FavoritesCommercial'),
);
export const FavoritesParts = lazyWithRetry(
    () => import('../components/auth/cabinet/favorites/FavoritesParts'),
);
export const TopsCompany = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/company/TopsCompany'),
);
export const TopsParts = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/parts/TopsParts'),
);
export const TopPlacements = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/placement/TopPlacements'),
);
export const TopsRent = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/rent/TopsRent'),
);
export const TopsSell = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/sell/TopsSell'),
);
export const TopsServices = lazyWithRetry(
    () => import('../components/auth/cabinet/payments/services/TopsServices'),
);
export const PlacementCabinet = lazyWithRetry(
    () => import('../components/auth/cabinet/region_services/PlacementCabinet'),
);
export const ServicesCabinet = lazyWithRetry(
    () => import('../components/auth/cabinet/region_services/ServicesCabinet'),
);
export const Settings = lazyWithRetry(
    () => import('../components/auth/cabinet/Settings'),
);
export const Verificate = lazyWithRetry(
    () => import('../components/auth/cabinet/Verificate'),
);
export const SignupCorporateForm = lazyWithRetry(
    () => import('../components/auth/forms/SignupCorporateForm'),
);
export const SignupDealerForm = lazyWithRetry(
    () => import('../components/auth/forms/SignupDealerForm'),
);
export const SignupUserForm = lazyWithRetry(
    () => import('../components/auth/forms/SignupUserForm'),
);
export const ForgotPasswordForm = lazyWithRetry(
    () => import('../components/auth/forms/ForgotPasswordForm'),
);
export const LoginForm = lazyWithRetry(
    () => import('../components/auth/forms/LoginForm'),
);
export const NewPasswordForm = lazyWithRetry(
    () => import('../components/auth/forms/NewPasswordForm'),
);
export const NewPhoneForm = lazyWithRetry(
    () => import('../components/auth/forms/NewPhoneForm'),
);
export const CheckautoExample = lazyWithRetry(
    () => import('../components/checkauto/information/CheckautoExample'),
);
export const CheckautoReport = lazyWithRetry(
    () => import('../components/checkauto/information/CheckautoReport'),
);
export const CheckautoCompany = lazyWithRetry(
    () => import('../components/checkauto/search/CheckautoCompany'),
);
export const SearchCheckautoFull = lazyWithRetry(
    () => import('../components/checkauto/search/SearchCheckautoFull'),
);
export const SearchCabinetCarPartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/car/SearchCabinetCarPartsFull'
        ),
);
export const SearchCabinetBikePartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/bike/SearchCabinetBikePartsFull'
        ),
);
export const SearchCabinetCommercialPartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/commercial/SearchCabinetCommercialPartsFull'
        ),
);
export const SearchCabinetAllPartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/SearchCabinetAllPartsFull'
        ),
);
export const PartsBikeList = lazyWithRetry(
    () => import('../components/lists/region_services/PartsBikeList'),
);
export const PartsCarList = lazyWithRetry(
    () => import('../components/lists/region_services/PartsCarList'),
);
export const PartsCommercialList = lazyWithRetry(
    () => import('../components/lists/region_services/PartsCommercialList'),
);
export const PartsList = lazyWithRetry(
    () => import('../components/lists/region_services/PartsList'),
);
export const SearchAllParts = lazyWithRetry(
    () => import('../components/region_services/search/parts/SearchAllParts'),
);
export const SearchAllPartsFull = lazyWithRetry(
    () =>
        import('../components/region_services/search/parts/SearchAllPartsFull'),
);
export const SearchBikeParts = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/bike/SearchBikeParts'
        ),
);
export const SearchBikePartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/bike/SearchBikePartsFull'
        ),
);
export const SearchCarParts = lazyWithRetry(
    () =>
        import('../components/region_services/search/parts/car/SearchCarParts'),
);
export const SearchCarPartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/car/SearchCarPartsFull'
        ),
);
export const SearchCommercialParts = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/commercial/SearchCommercialParts'
        ),
);
export const SearchCommercialPartsFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/parts/commercial/SearchCommercialPartsFull'
        ),
);
export const Accessory = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/accessory/Accessory'
        ),
);
export const Carbody = lazyWithRetry(
    () => import('../components/region_services/adverts/parts/carbody/Carbody'),
);
export const Maintenance = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/maintenance/Maintenance'
        ),
);
export const Brakes = lazyWithRetry(
    () => import('../components/region_services/adverts/parts/brakes/Brakes'),
);
export const Wheels = lazyWithRetry(
    () => import('../components/region_services/adverts/parts/wheels/Wheels'),
);
export const Transmission = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/transmission/Transmission'
        ),
);
export const Suspension = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/suspension/Suspension'
        ),
);
export const GasEquipment = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/gasEquipment/GasEquipment'
        ),
);
export const Interior = lazyWithRetry(
    () =>
        import('../components/region_services/adverts/parts/interior/Interior'),
);
export const Equipment = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/parts/equipment/Equipment'
        ),
);
export const Engine = lazyWithRetry(
    () => import('../components/region_services/adverts/parts/engine/Engine'),
);
export const Electric = lazyWithRetry(
    () =>
        import('../components/region_services/adverts/parts/electric/Electric'),
);
export const Heating = lazyWithRetry(
    () => import('../components/region_services/adverts/parts/heating/Heating'),
);
export const PartsAllDetails = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/all/parts/PartsAllDetails'
        ),
);
export const PlacementAllDetails = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/all/placement/PlacementAllDetails'
        ),
);
export const PlacementAutoservice = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/placement/PlacementAutoservice'
        ),
);
export const PlacementBox = lazyWithRetry(
    () =>
        import('../components/region_services/adverts/placement/PlacementBox'),
);
export const PlacementCarwash = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/placement/PlacementCarwash'
        ),
);
export const PlacementGarage = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/placement/PlacementGarage'
        ),
);
export const PlacementPainting = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/placement/PlacementPainting'
        ),
);
export const PlacementTyreservice = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/placement/PlacementTyreservice'
        ),
);
export const PlacementAutoServiceForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementAutoServiceForm'
        ),
);
export const PlacementBoxForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementBoxForm'
        ),
);
export const PlacementCarWashForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementCarWashForm'
        ),
);
export const PlacementGarageForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementGarageForm'
        ),
);
export const PlacementPaintingForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementPaintingForm'
        ),
);
export const PlacementTyreServiceForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/placement/PlacementTyreServiceForm'
        ),
);
export const SearchPlacement = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/placement/SearchPlacement'
        ),
);
export const SearchPlacementFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/placement/SearchPlacementFull'
        ),
);
export const AutoschoolForm = lazyWithRetry(
    () =>
        import('../components/region_services/forms/service/AutoSchoolFormNew'),
);
export const AutoserviceForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/service/AutoServiceFormNew'
        ),
);
export const CarwashForm = lazyWithRetry(
    () => import('../components/region_services/forms/service/CarWashFormNew'),
);
export const PaintingForm = lazyWithRetry(
    () => import('../components/region_services/forms/service/PaintingForm'),
);
export const TowtruckForm = lazyWithRetry(
    () => import('../components/region_services/forms/service/TowTruckForm'),
);
export const TyreserviceForm = lazyWithRetry(
    () =>
        import(
            '../components/region_services/forms/service/TyreServiceFormNew'
        ),
);
export const DisassemblyForm = lazyWithRetry(
    () => import('../components/region_services/forms/service/DisassemblyForm'),
);
export const Autoschool = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Autoschool'),
);
export const Autoservice = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Autoservice'),
);
export const Carwash = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Carwash'),
);
export const Disassembly = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Disassembly'),
);
export const Painting = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Painting'),
);
export const Towtruck = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Towtruck'),
);
export const Tyreservice = lazyWithRetry(
    () => import('../components/region_services/adverts/services/Tyreservice'),
);
export const ServicesAllDetails = lazyWithRetry(
    () =>
        import(
            '../components/region_services/adverts/all/services/ServicesAllDetails'
        ),
);
export const SearchService = lazyWithRetry(
    () => import('../components/region_services/search/service/SearchService'),
);
export const SearchServiceFull = lazyWithRetry(
    () =>
        import(
            '../components/region_services/search/service/SearchServiceFull'
        ),
);
export const NotFound = lazyWithRetry(
    () => import('../components/main_page/main/NotFound'),
);
export const AddAdvert = lazyWithRetry(
    () => import('../components/main_page/main/advertsting/AddAdvert'),
);
export const QrLanding = lazyWithRetry(
    () => import('../components/main_page/main/advertsting/QrLanding'),
);
export const PricingPage = lazyWithRetry(
    () => import('../components/main_page/main/advertsting/PricingPage'),
);
export const NewsAdvertPage = lazyWithRetry(
    () => import('../components/main_page/form_components/NewsAdvertPage'),
);
export const NewsListPage = lazyWithRetry(
    () => import('../components/main_page/form_components/NewsListPage'),
);
export const AuthCallback = lazyWithRetry(
    () => import('../components/auth/forms/AuthCallback'),
);
export const ComparePage = lazyWithRetry(
    () => import('../components/compare/ComparePage'),
);
